<script setup>
import MBadge from "./../MBadge";
defineProps(MBadge.props);
</script>
<template>
  <m-badge class="clinical-code-badge" v-bind="$props"><slot /> </m-badge>
</template>
<style lang="scss">
.clinical-code-badge {
  border-radius: 4px;
  padding: 0 5px;

  background-color: var(--grey-lightest);
  color: var(--text-color);
  border: 1px solid var(--grey-darkest) !important;

  font-size: 14px;
  line-height: 150%;

  font-style: normal;
  font-weight: normal;

  border: 1px solid #c1c6cd;
  white-space: break-spaces;
}
</style>
